import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HotelService } from '../services/hotel.service';
import { Hotel } from '../hotel';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';

@Component({
  selector: 'app-orderlist',
  templateUrl: './orderlist.component.html',
  styleUrls: ['./orderlist.component.css']
})
export class OrderlistComponent implements OnInit {
  model = new Hotel;
  orders: any;
  value: any;
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild('print') print: ElementRef

  constructor(private router: Router, private hotelService: HotelService) { }

  ngOnInit() {
    this.orders = [];
    this.getOrderList();

  }
  total: any = 0;
  totalPending: any = 0;
  totalPaid: any = 0;
  discount: any = 0;
  status:any = 1;
  getOrderList() {

    this.hotelService
      .getOrderList()
      .subscribe(response => {
        this.orders = response
        
        this.dtTrigger.next();

      })
  }

  getSearchOrderList() {
    $("#print").DataTable().destroy();
    this.hotelService
      .getSearchOrderList(this.model)
      .subscribe(response => {
        this.orders = response
        setTimeout(() => {
          this.dtTrigger.next();
        }, 1000);

      })
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  setActive(menu) {

    $('li').removeClass();
    $('#' + menu).addClass("active");
  }

  searchReport() {
    let from = this.model.fromdate.toISOString().substring(0, 10);
    let to = this.model.todate.toISOString().substring(0, 10);
    this.router.navigate(['/searchreport', from, to]);
    /*this.hotelService
        .getSearchHotelList(this.model)
        .subscribe( response => {
          this.hotel = response
        })*/
  }
  dsbl: any;
  restorepage; printcontent
  prints() {
    $('#act').css('display', 'none')
    $("[id$='actbtn']").css('display', 'none')

    this.dsbl = true;
    setTimeout(() => {
      this.dsbl = false;
    }, 5000);
    html2canvas(this.print.nativeElement).then(function (canvas) {
      var imgData = canvas.toDataURL("image/png");
      var imgWidth = 200;
      var pageHeight = 295;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      var heightLeft = imgHeight;
      var doc = new jsPDF('p', 'mm');
      var position = 13;

      doc.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight + 13;
        doc.addPage();
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      window.print();

      doc.save('file.pdf');
      $('#act').css('display', 'block')
      $("[id$='actbtn']").css('display', 'block')
    });

  }
  data
  deleteBill(billNo: string) {
    if (confirm("Are you sure to delete bill")) {
      this.data = { "bill_no": billNo }
      this.hotelService
        .deleteBill(this.data)
        .subscribe(response => {
          this.totalPending = 0;
          this.totalPaid = 0;
          this.total = 0;
          this.discount = 0;
          this.getOrderList();
          $("#print").DataTable().destroy();
        });
    }
  }

  check_status(event){
    // console.log(event.target.value);
    this.model['status'] = event.target.value;
    // console.log(this.model)
    $("#print").DataTable().destroy();
    this.hotelService
      .getSearchOrderList(this.model)
      .subscribe(response => {
        this.orders = response
        setTimeout(() => {
          this.dtTrigger.next();
        }, 1000);

      })
  }

  change_status(id,status){
    if(confirm("Are you sure ?")){
      this.hotelService
      .changeStatus({order_id:id,status:status})
      .subscribe(response => {
        setTimeout(() => {
          this.getSearchOrderList()
        }, 100);
      })
    }    
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/orderlist/orderlist.component.ts